import React from 'react'
import "./index.css"

import {
  Routes,
  Route,
  Navigate
  // Link,
  // useParams,
  // useRouteMatch
} from "react-router-dom";

import LoginPage from "./pages/LoginPage";
import Admin from "./pages/Admin";
import ErrorPage from "./pages/ErrorPage";
import Dashboard from './pages/admin/Dashboard';
import AdminErrorPage from './pages/admin/AdminErrorPage';
import ActivateAccount from './pages/ActivateAccount';
import PasswordReset from './pages/PasswordReset';
import UserProfile from './pages/admin/settings/UserProfile';
import Security from './pages/admin/settings/Security';
import ScrollToTop from './components/layouts/ScrollToTop';
import { Provider } from 'react-redux';
import store from './store/store';
import ErrorNotifier from './components/elements/ErrorNotifier';
import SuccessNotifier from './components/elements/SuccessNotifier';
import Application from './pages/admin/administration/applications/Application';
import Applications from './pages/admin/administration/applications/Applications';
import ApplicationAnalytics from './pages/admin/administration/applications/ApplicationAnalytics';

import AcademicSessions from './pages/admin/administration/academic-sessions/AcademicSessions';
import Parents from './pages/admin/parents/Parents';
import Parent from './pages/admin/parents/Parent';
import Student from './pages/admin/students/Student';
import Students from './pages/admin/students/Students';
import Admissions from './pages/admin/administration/admissions/Admissions';
import Examinations from './pages/admin/administration/examinations/Examinations';
import Academics from './pages/admin/Academics';
import AcademicsDashboard from './pages/admin/academics/AcademicsDashboard';
import AdministrationDashboard from './pages/admin/administration/AdministrationDashboard';
import Administration from './pages/admin/Administration';
import Departments from './pages/admin/administration/departments/Departments';
import Subjects from './pages/admin/academics/subjects/Subjects';
import Assessments from './pages/admin/academics/assessments/Assessments';
import TimeTables from './pages/admin/academics/time-tables/TimeTables';
import Payments from './pages/admin/accounting/Payments';
import Fees from './pages/admin/accounting/Fees';
import AccountingDashboard from './pages/admin/accounting/AccountingDashboard';
import Accounting from './pages/admin/Accounting';
import ClassesDivisions from './pages/admin/administration/classes-divisions/ClassesDivisions';
import Documents from './pages/admin/administration/documents/Documents';
import Document from './pages/admin/administration/documents/Document';
import NewDocument from './pages/admin/administration/documents/NewDocument';
import ClassDetails from './pages/admin/administration/classes-divisions/ClassDetails';
import Settings from './pages/admin/Settings';
import Roles from './pages/admin/settings/roles-permissions/Roles';
import RoleDetails from './pages/admin/settings/roles-permissions/RoleDetails';
import NewRole from './pages/admin/settings/roles-permissions/NewRole';
import AuditLogs from './pages/admin/settings/AuditLogs';
import Users from './pages/admin/settings/users/Users';
import Inventory from './pages/admin/Inventory';
import Requests from './pages/admin/inventory/requests/Requests';
import InventoryDashboard from './pages/admin/inventory/InventoryDashboard';
// import SportsEquipment from './pages/admin/inventory/sports-equipment/SportsEquipment';
// import KitchenStock from './pages/admin/inventory/kitchen/KitchenStock';
// import LibraryStock from './pages/admin/inventory/library-stock/LibraryStock';
import SystemUsers from './pages/admin/settings/system-users/SystemUsers';
import CollegeStaff from './pages/admin/college-staff/CollegeStaff';
import CollegeStaffProfile from './pages/admin/college-staff/CollegeStaffProfile';
import OnboardStaff from './pages/admin/college-staff/OnboardStaff';
import StaffDesignations from './pages/admin/administration/staff-designations/StaffDesignations';
import Invoices from './pages/admin/accounting/invoices/Invoices';
import Admission from './pages/admin/administration/admissions/Admission';
import Downloadables from './pages/admin/administration/downloadables/Downloadables';
import EditApplication from './pages/admin/administration/applications/EditApplication';
import CollegeAccounts from './pages/admin/accounting/college-accounts/CollegeAccounts';
import AccountDetails from './pages/admin/accounting/college-accounts/AccountDetails';
import Invoice from './pages/admin/accounting/invoices/Invoice';
import StaffOnboarding from './pages/StaffOnboarding';
import SundryAccounts from './pages/admin/accounting/sundry/SundryAccounts';
import SundryAccountDetails from './pages/admin/accounting/sundry/SundryAccountDetails';
import AcademicSessionDetails from './pages/admin/administration/academic-sessions/AcademicSessionDetails';
import InventoryItems from './pages/admin/inventory/inventory-items/InventoryItems';
import InventoryItemDetails from './pages/admin/inventory/inventory-items/InventoryItemDetails';
import SubjectDetails from './pages/admin/academics/subjects/SubjectDetails';
import NewInventoryItem from './pages/admin/inventory/inventory-items/NewInventoryItem';
import NewInventoryCategory from './pages/admin/inventory/categories/NewInventoryCategory';
import Scholarships from './pages/admin/administration/scholarships/Scholarships';
import ScholarshipDetails from './pages/admin/administration/scholarships/ScholarshipDetails';
import AssessmentDetails from './pages/admin/academics/assessments/AssessmentDetails';
import UserStaffProfile from './pages/admin/settings/userStaffProfile'
import House from './pages/admin/administration/housing/House';
import Houses from './pages/admin/administration/housing/Houses';
import AcademicSettings from './pages/admin/academics/academic-settings/AcademicSettings';
import Exeats from './pages/admin/administration/exeats/Exeats';

export default function App() {
  return (
    <main>
    <Provider store={store}>
      <ErrorNotifier />
      <SuccessNotifier />
      <ScrollToTop>
          <Routes>
            <Route path="/" exact element={<LoginPage />} />
            <Route path="/password-reset" exact element={<PasswordReset />} />
            <Route path="/activate-account/:activationCode" exact element={<ActivateAccount />} />
            <Route path="/staff-onboarding/:invitationCode/" exact element={<StaffOnboarding />} />
            <Route path="/admin" element={<Admin />}>
              <Route path="/admin/" element={<Navigate replace to="/admin/dashboard" />} />
              <Route path="/admin/dashboard" element={<Dashboard />} />
              
              <Route path="/admin/parents" element={<Parents />} />
              <Route path="/admin/parents/parent-profile/:parentId" element={<Parent />} />
              
              <Route path="/admin/students" element={<Students />} />
              <Route path="/admin/students/student/:studentId" element={<Student />} />

              <Route path="/admin/college-staff" element={<CollegeStaff />} />
              <Route path="/admin/college-staff/onboard-new-staff" element={<OnboardStaff />} />
              <Route path="/admin/college-staff/:staffId" element={<CollegeStaffProfile />} />

              <Route path="/admin/administration" element={<Administration />}>
                <Route path="/admin/administration/" element={<Navigate replace to="/admin/administration/dashboard" />} />
                <Route path="/admin/administration/dashboard" element={<AdministrationDashboard />} />
                <Route path="/admin/administration/academic-sessions" element={<AcademicSessions />} />
                <Route path="/admin/administration/academic-sessions/:sessionId" element={<AcademicSessionDetails />} />
                <Route path="/admin/administration/admissions" element={<Admissions />} />
                <Route path="/admin/administration/admissions/:admissionId" element={<Admission />} />
                <Route path="/admin/administration/applications" element={<Applications />} />
                <Route path="/admin/administration/applications/analytics" element={<ApplicationAnalytics />} />
                <Route path="/admin/administration/applications/:applicationId" element={<Application />} />
                <Route path="/admin/administration/applications/:applicationId/:admissionId/edit" element={<EditApplication />} />
                <Route path="/admin/administration/examinations" element={<Examinations />} />

                <Route path="/admin/administration/exeats" element={<Exeats />} />

                <Route path="/admin/administration/classes" element={<ClassesDivisions />} />
                <Route path="/admin/administration/classes/:classId" element={<ClassDetails />} />

                <Route path="/admin/administration/housing/houses" element={<Houses />} />
                <Route path="/admin/administration/housing/houses/:houseId" element={<House />} />

                <Route path="/admin/administration/departments" element={<Departments />} />
                <Route path="/admin/administration/designations" element={<StaffDesignations />} />
                <Route path="/admin/administration/documents" element={<Documents />} />
                <Route path="/admin/administration/documents/details/:documentId" element={<Document />} />
                <Route path="/admin/administration/documents/:documentId" element={<NewDocument />} />
                <Route path="/admin/administration/downloadables" element={<Downloadables />} />
                <Route path="/admin/administration/scholarships" element={<Scholarships />} />
                <Route path="/admin/administration/scholarships/:scholarshipId" element={<ScholarshipDetails />} />
              </Route> 

              <Route path="/admin/academics" element={<Academics />}>
                <Route path="/admin/academics/" element={<Navigate replace to="/admin/academics/dashboard" />} />
                <Route path="/admin/academics/dashboard" element={<AcademicsDashboard />} />
                <Route path="/admin/academics/subjects" element={<Subjects />} />
                <Route path="/admin/academics/subjects/:subjectId" element={<SubjectDetails />} />
                <Route path="/admin/academics/timetables" element={<TimeTables />} />
                <Route path="/admin/academics/assessments" element={<Assessments />} />
                <Route path="/admin/academics/academic-settings" element={<AcademicSettings />} />
                <Route path="/admin/academics/assessments/:assessmentId" element={<AssessmentDetails />} />
              </Route> 

              <Route path="/admin/accounting" element={<Accounting />}>
                <Route path="/admin/accounting/" element={<Navigate replace to="/admin/accounting/dashboard" />} />
                <Route path="/admin/accounting/dashboard" element={<AccountingDashboard />} />
                <Route path="/admin/accounting/college-accounts" element={<CollegeAccounts />} />
                <Route path="/admin/accounting/college-accounts/:accountId" element={<AccountDetails />} />
                <Route path="/admin/accounting/fees" element={<Fees />} />
                <Route path="/admin/accounting/invoices" element={<Invoices />} />
                <Route path="/admin/accounting/invoices/:invoiceId" element={<Invoice />} />
                <Route path="/admin/accounting/payments" element={<Payments />} />
                <Route path="/admin/accounting/sundry" element={<SundryAccounts />} />
                <Route path="/admin/accounting/sundry/:accountId" element={<SundryAccountDetails />} />
              </Route> 

              <Route path="/admin/settings" element={<Settings />}>
                <Route path="/admin/settings/" element={<Navigate replace to="/admin/settings/user-profile" />} />
                <Route path="/admin/settings/user-profile" element={<UserProfile />} />
                <Route path="/admin/settings/user-staff-profile" element={<UserStaffProfile />} />
                {/* <Route path="/admin/settings/notifications" element={<Notifications />} /> */}
                <Route path="/admin/settings/security" element={<Security />} />

                <Route path="/admin/settings/audit-logs" element={<AuditLogs />} />

                <Route path="/admin/settings/system-users" element={<SystemUsers />} />
                
                <Route path="/admin/settings/roles-permissions" element={<Roles />} />
                <Route path="/admin/settings/roles-permissions/role/:roleId" element={<RoleDetails />} />
                <Route path="/admin/settings/roles-permissions/new-role" element={<NewRole />} />
                
                <Route path="/admin/settings/users" element={<Users />} />
              </Route> 

              <Route path="/admin/inventory" element={<Inventory />}>
                <Route path="/admin/inventory/" element={<Navigate replace to="/admin/inventory/dashboard" />} />
                <Route path="/admin/inventory/dashboard" element={<InventoryDashboard />} />
                <Route path="/admin/inventory/requests" element={<Requests />} />
                <Route path="/admin/inventory/inventory-items" element={<InventoryItems />} />
                <Route path="/admin/inventory/item-categories/new" element={<NewInventoryCategory />} />
                <Route path="/admin/inventory/inventory-items/new" element={<NewInventoryItem />} />
                <Route path="/admin/inventory/inventory-items/details/:itemId" element={<InventoryItemDetails />} />
                {/* <Route path="/admin/inventory/sports-equipment" element={<SportsEquipment />} />
                <Route path="/admin/inventory/kitchen-stock" element={<KitchenStock />} /> */}
                {/* <Route path="/admin/academics/timetables" element={<TimeTables />} />
                <Route path="/admin/academics/assessments" element={<Assessments />} /> */}
              </Route> 

              <Route path="/admin/*" element={<AdminErrorPage />} />
            </Route>
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </ScrollToTop>

    </Provider>
    </main>
  );
}
